<template>
  <div class="daterange daterange--double one"></div>
</template>

<script>
import Calendar from 'baremetrics-calendar'
import jQuery from 'jquery'
import { DateTime } from 'luxon'
import store from '@/store'

const between = (from, to) => {
  return [from, to]
}

export default {
  name: 'ControlDateRangeInner',
  props: {
    filter: { type: Object, default: () => null },
  },
  computed: {
    Timezone: () => store.state.user.me.Timezone,
  },

  mounted() {
    this.makeCalendar()
  },

  methods: {
    makeCalendar() {
      const self = this
      const $el = jQuery(self.$el)

      const todayDate = this.convertDate(DateTime.local())
      const latest_date = todayDate
      const earliest_date = this.convertDate(
        DateTime.fromObject({ year: 2000 }),
      )

      // find first day and last day of week
      const findWeek = (d) => {
        const weekday = d.weekday
        const minus = weekday - 1
        const plus = 7 - weekday
        return {
          startOf: d.minus({ days: minus }).startOf('day'),
          endOf: d.plus({ days: plus }).endOf('day')
        }
      }

      const yesterday = (today) => {
        const y = today.minus({ days: 1 })
        return { label: "Yesterday", start: y.startOf('days').toISO(), end: y.endOf('days').toISO() }
      }
      const thisweek = (today) => {
        const week = findWeek(today)
        return { label: 'This week', start: week.startOf.toISO(), end: week.endOf.toISO() }
      }
      const lastweek = (today) => {
        const week = findWeek(today.minus({ weeks: 1 }))
        return { label: 'Last week', start: week.startOf.toISO(), end: week.endOf.toISO() }
      }
      const sevendays = (today) => {
        const day = today.startOf('days').minus({ days: 7 })
        return {
          label: 'Last 7 days',
          start: day.startOf('days').toISO(),
          end: today.endOf('days').toISO()
        }
      }

      self.$options.calendar = new Calendar({
        element: $el,
        // current_date: DateTime.local().toFormat(DateTime.DATE_SHORT),
        // current_date: DateTime.local().toJSDate(),
        earliest_date: earliest_date.startOf('day').toISO(),
        // set latest date = user Timezone
        latest_date: latest_date.startOf('day').toISO(),
        // start_date: DateTime.local().toISODate(),
        // end_date: DateTime.local().toISODate(),
        format: { input: 'M/D/YYYY' },
        required: false,

        

        presets: [
          {
            label: 'Today',
            start: todayDate.startOf('day'),
            end: todayDate.endOf('day'),
          },
          yesterday(todayDate),
          thisweek(todayDate),
          lastweek(todayDate),
          sevendays(todayDate),
          {
            label: 'All time',
            start: earliest_date.startOf('day').toISO(),
            end: todayDate.endOf('day').toISO(),
          },
        ],

        callback: function() {
          // convert back to UTC date
          const startIso = DateTime.fromJSDate(this.start_date.toDate(), {
            setZone: true,
          })
            .setZone('utc', { keepLocalTime: true })
            .toISODate()

          // convert back to utc
          const endIso = DateTime.fromJSDate(this.end_date.toDate(), {
            setZone: true,
          })
            .setZone('utc', { keepLocalTime: true })
            .toISODate()
          //
          const filter = between(startIso, endIso)
          self.$emit('change', filter)
        },
      })
    },

    // get today date but with Timezone of local
    // ex: local date today is 2019/03/28 GMT +7
    // we will got 2019/03/28 with GMT = account's Timezone
    convertDate(date) {
      return date.setZone(this.Timezone).setZone(null, { keepLocalTime: true })
    },
  },
}
</script>

<style lang="scss">
@import '@/style/inject';
@import '~baremetrics-calendar/public/css/application.css';

.daterange .dr-input .dr-dates .dr-date {
  font-size: $size-7;
}

.daterange .dr-input {
  height: 30px;
  border-color: $border;
}

.daterange .dr-selections .dr-preset-list {
  font-size: $size-7;
}

.daterange .dr-selections .dr-calendar .dr-day-list {
  font-size: $size-7;
}
</style>
